import React from 'react';
import { Box, Tooltip, Typography, Button } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PropTypes from 'prop-types';

export default function UpdaterButton({ updaterList, handleUpdaterMenu }) {
  return (
    <Box>
      {updaterList.length > 0 && (
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          <Tooltip title="የዓርታኢ መረጃ አሰይ" color="success" arrow>
            <Button onClick={handleUpdaterMenu} sx={{ ml: 1, pt: 0, pb: 0, color: 'text.secondary' }}>
              ዓርታኢ
              <ArrowDropDownIcon />
            </Button>
          </Tooltip>
        </Typography>
      )}
      {updaterList.length === 0 && (
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          ዓርታኢ የለውም
        </Typography>
      )}
    </Box>
  );
}

UpdaterButton.propTypes = {
  updaterList: PropTypes.array.isRequired,
  handleUpdaterMenu: PropTypes.func.isRequired,
};
